class LocalStorageHelper {

    /**
     * Sets data to localstorage.
     * @param storageKey Key of value
     * @param storageValue Value to save
     */
    setToLocal(storageKey, storageValue) {
        window.localStorage.setItem(storageKey, JSON.stringify(storageValue));
    }
}
export default new LocalStorageHelper();